import { Injectable } from '@angular/core';

@Injectable()
export class CommonService {

  constructor() { }

  static createDashlessGuid(): string {
    let tmpUuid = '';
    for (let ii = 0; ii < 8; ii++) {
      tmpUuid += Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1).toLowerCase();
    }

    return tmpUuid;
  }

  static escapeRegexLiteral(literal: string): string {
    return literal.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

  static compareCaseInsensitive(locale: string, a: string, b: string): boolean {
    if (a && typeof a !== 'string' || b && typeof b !== 'string') {
      return a === b;
    }

    const aText = a || '';
    const bText = b || '';

    if (this._localeCompareCaseInsensitive('en', 'a', 'A')) {
      return this._localeCompareCaseInsensitive(locale, aText, bText);
    }

    return new RegExp(`^${CommonService.escapeRegexLiteral(aText)}$`, 'i').test(b);
  }

  private static _localeCompareCaseInsensitive(locale: string, a: string, b: string): boolean {
    return a.localeCompare(b, locale, { usage: 'search', sensitivity: 'accent' }) === 0;
  }
}
